import { createContext } from 'react';
import type { SessionUser } from '@sw/tenant-types';

/**
 * Shape del auth state expuesto via React context. Story SW-311.
 *
 * - `isLoading` cubre la fetch inicial del `/me` (al mount del provider).
 * - `isFetching` cubre fetches subsiguientes (refetch on focus, manual invalidate).
 *   El UI puede ignorarlo o mostrar spinner sutil — no bloquea como `isLoading`.
 * - `error` se setea SOLO si el fetch falla con un status NO-401. Un 401 es "no
 *   estás autenticado" — caso esperado, no error.
 */
export interface AuthContextValue {
  user: SessionUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
  /** Fuerza un re-fetch del /me — útil después de un login manual. */
  refetch: () => Promise<void>;
}

const defaultValue: AuthContextValue = {
  user: null,
  isAuthenticated: false,
  isLoading: true,
  isFetching: false,
  error: null,
  refetch: async () => {},
};

export const AuthContext = createContext<AuthContextValue>(defaultValue);
